import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  getCreditEligibilityReport: (params: ParamsModel = {page: 1, limit: 15}) => ({
    type: actionTypes.GET_CREDIT_ELIGIBILITY_REPORT_START,
    payload: params,
  }),
  getCreditEligibilityReportSuccess: (data: any) => ({
    type: actionTypes.GET_CREDIT_ELIGIBILITY_REPORT_SUCCESS,
    payload: data,
  }),
  getCreditEligibilityReportFinish: () => ({
    type: actionTypes.GET_CREDIT_ELIGIBILITY_REPORT_FINISH,
  }),
}
